// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabsContainer_container__FM6O3 {
  margin-bottom: -1px;
  display: flex;
  gap: 0.5rem;
}

.TabsContainer_tabs-container__FQ63V {
  display: flex;
  gap: 0.5rem;
  overflow-x: scroll;
  scrollbar-width: none;
}

.TabsContainer_scroll-button__ZnCXs {
  width: 2rem;
  background: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Misc/TabsNavigation/TabsContainer.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF","sourcesContent":[".container {\n  margin-bottom: -1px;\n  display: flex;\n  gap: 0.5rem;\n}\n\n.tabs-container {\n  display: flex;\n  gap: 0.5rem;\n  overflow-x: scroll;\n  scrollbar-width: none;\n}\n\n.scroll-button {\n  width: 2rem;\n  background: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TabsContainer_container__FM6O3`,
	"tabs-container": `TabsContainer_tabs-container__FQ63V`,
	"scroll-button": `TabsContainer_scroll-button__ZnCXs`
};
export default ___CSS_LOADER_EXPORT___;
